import "./CleaningAndWashing.module.css";
import Header from "@/reusable_sections/Header";
import HeroCleaning from "./sections/HeroCleaning";
import ApplicationsFaq from "./sections/ApplicationsFaq";
import CleaningOverview from "./sections/CleaningOverview";
import TechnicalBenefits from "./sections/TechnicalBenefits";
import Callout from "./sections/Callout";
import Footer from "@/reusable_sections/Footer";
export default function CleaningAndWashingPage() {
  return <div>
      <Header />
      
      <HeroCleaning />
      <ApplicationsFaq />
      <CleaningOverview />
      <TechnicalBenefits />
      <Callout />
      <Footer />
    </div>;
}